export default __webpack_public_path__ + "static/media/21.cc52ec60.mp3";